/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import { useRef, useMemo, useEffect } from 'react';
import classNames from 'classnames';

import styles from './ImageCarouselDots.module.scss';

const MAX_DOTS = 7;

const ImageCarouselDots = ({ nItems, onDotClick, selectedItem }) => {
  const maxItems = Math.min(nItems, MAX_DOTS);
  const dotsOffset = Math.floor(maxItems / 2) - 1;

  const containerRef = useRef(null);
  const handleDotClick = index => e => {
    e.preventDefault();
    e.stopPropagation();
    onDotClick(index);
  };

  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const dots = useMemo(() => {
    const pre = [];
    const show = [];
    const post = [];
    for (let i = 0; i < nItems; i++) {
      if (i < selectedItem - dotsOffset) {
        pre.push(i);
      } else if (i > selectedItem + dotsOffset) {
        post.push(i);
      } else {
        show.push(i);
      }
    }

    return { pre, show, post };
  }, [nItems, selectedItem]);

  useEffect(() => {
    const itemsBeforeMoving = dotsOffset + 1;
    let translateX = 0;

    if (selectedItem <= itemsBeforeMoving) {
      translateX = 0;
    } else if (
      selectedItem > itemsBeforeMoving &&
      selectedItem < nItems - itemsBeforeMoving
    ) {
      // Selected item index minus items to the left or right fixed by the size of each dot
      translateX = (selectedItem - itemsBeforeMoving) * 20;
    } else {
      // Total item spacing minus maxItems spacing
      translateX = nItems * 20 - maxItems * 20;
    }

    containerRef.current.style.transform = `translateX(-${translateX}px)`;
  }, [selectedItem, nItems]);

  return (
    <div
      className={styles['image-carousel-dots']}
      role="button"
      tabIndex={0}
      onClick={handleClick}
    >
      <ul ref={containerRef} className={styles['image-carousel-dots__wrapper']}>
        {Array.from({ length: nItems }).map((_, index) => (
          <li
            key={index}
            role="button"
            tabIndex={0}
            className={classNames(styles['image-carousel-dots__dot'], {
              [styles['image-carousel-dots__dot--selected']]:
                selectedItem === index,
              [styles['image-carousel-dots__dot--bigger']]:
                dots.show.includes(index)
            })}
            onClick={handleDotClick(index)}
          />
        ))}
      </ul>
    </div>
  );
};

export default ImageCarouselDots;
